import { render, staticRenderFns } from "./AdministrativePermitsDocumentCard.vue?vue&type=template&id=0db087ee"
import script from "./AdministrativePermitsDocumentCard.vue?vue&type=script&lang=js"
export * from "./AdministrativePermitsDocumentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports